

<div [ngClass]="{'col-12 col-xl-6' : !allSettings}">
  <div class="card">
    <div class="card-header">
      <div class="float-end fit-content h-100 d-flex flex-column align-items-end mt-2 gap-2">
        <!-- <div class="d-flex gap-2">
          <span> Estado </span>
          <span class="badge fs-6" [ngClass]="statData.status === 'running' ? 'bg-secondary' : 'bg-danger'">{{statData.status}}</span>
        </div> -->
        <div class="d-flex gap-2 align-items-bottom">
          <label class="text-end card-subtitle text-muted fs-6 "   >Estado</label>
          <span
            class="d-inline-block rounded-circle flex-shrink-0"
            [ngClass]="statData?.status === 'running' ? 'bg-success' : 'bg-danger'"
            style="width: 12px; height: 12px;"
          ></span>
          <!-- <span
            class="d-inline-block rounded-circle"
            [ngClass]="statData.status === 'running'? 'bg-bg-secondary' : 'bg-danger'"
            style="width: 12px; height: 12px;"
            [attr.title]="statData?.sta_connected ? 'Connected' : 'Disconnected'"
            [attr.aria-label]="statData?.sta_connected ? 'Connected' : 'Disconnected'"
          ></span> -->
        </div>

        <div class="d-flex align-items-center gap-2">

          <label class="text-end card-subtitle text-muted fs-6 ">Equipos conectados:</label>
          <span class="fs-6 badge bg-light text-muted" > {{statData?.clients_connected}} </span>

        </div>
      </div>
      <h5 class="card-title">Bluetooth</h5>
      <h6 class="card-subtitle text-muted">Parámetros de configuración del bluetooth</h6>
    </div>

    <div class="card-body">
      <form>


        <div class="form-group row">
          <label class="col-form-label col-sm-4 text-sm-right">{{"Name" | translate}}</label>
          <div class="col-sm-8">
            <input [disabled]="true" type="text" class="form-control"
              placeholder="{{'Name' | translate}}" name="name" [value]="cfgData?.device_name" >
          </div>
        </div>
        <div class="form-group row">
          <label class="col-form-label col-sm-4 text-sm-right">{{"Modo de auto-reinicio " |
            translate}}</label>
          <div class="col-sm-8">
            <input [disabled]="true" type="text" class="form-control"
              placeholder="{{'Modo de auto-reinicio ' | translate}}" name="auto_restart_adv" [value]="cfgData?.auto_restart_advertising"
            >
          </div>
        </div>

        <div class="form-group row">
          <div class="col-sm-10 ms-sm-auto">
            <button type="submit" class="btn btn-primary" (click)="save()" [disabled]="!changesMade">{{"overwrite" |
              translate}}</button>
            <button type="submit" class="btn btn-light ms-2" [disabled]="!changesMade">{{"restore"
              | translate}}</button>
          </div>

        </div>
        <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="error!=''">
          <div class="alert-message">
            {{ error }}
          </div>
        </div>
        <div class="alert alert-success alert-dismissible" role="alert" *ngIf="successMessage">
          <div class="alert-message">
            {{"updatedSuccesfully" | translate}}
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
